import { ApiMethod, getRaw } from 'services/api';
import { useRestMutation, useRestQuery, UseRestMutationOptions } from 'utils/hooks/api';
import type { MetricsByOrganization } from 'modules/internalMetrics';

export const INTERNAL_METRICS_URL = '/i/metrics.json';
export const METRICS_BY_ORG_URL = '/admin/end_users';
export const NEW_ORGANIZATIONS_URL = '/admin/newOrganizationReact';
export const PROJECTS_URL = '/i/projects.json';
export const USERS_URL = '/i/admin/users';
export const IMPERSONATE_USER_URL = '/settings/viewAsUser';

export const useCreateNewOrganization = (options?: UseRestMutationOptions) =>
  useRestMutation(NEW_ORGANIZATIONS_URL, ApiMethod.post, options);

export const getInternalMetrics = () => getRaw(INTERNAL_METRICS_URL);

export const getUsers = () => getRaw(USERS_URL);

export const useGetUsers = () => useRestQuery(USERS_URL);

export const getMetricsByOrganization = (data: MetricsByOrganization) =>
  getRaw(METRICS_BY_ORG_URL, {
    params: {
      organizationId: data.orgId,
      startDateTime: data.startDateTime,
      endDateTime: data.endDateTime,
      includeArchivedProjects: data.archivedProjects,
    },
  });

export const impersonateUserRequest = (email: string) =>
  getRaw(`${IMPERSONATE_USER_URL}?email=${encodeURIComponent(email)}`);
